<template>
  <section class="product-typesets">
    <header>
      <h2>{{typeset.title}}</h2>
      <p class="subtitle">
        {{typeset.subtitle}}
      </p>
    </header>
    <div class="container text-center">
      <img v-lazy="typeset.image" class="hidden-xs" alt="" draggable="false">
      <img v-lazy="typeset.imageMobile" class="visible-xs" alt="" draggable="false">
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductTypesets',
  props: {
    typeset: Object
  }
}
</script>

<style lang="scss">
</style>
